/**
 * Created by Ivan on 30.01.2026
 */

let KrakenFeastMissionWindow;

switch (cleverapps.config.ui) {
    case "riddles":
        KrakenFeastMissionWindow = RiddlesKrakenFeastWindow;
        break;
    case "wooden":
        KrakenFeastMissionWindow = WoodenKrakenFeastWindow;
        break;
    case "tropical":
        KrakenFeastMissionWindow = TropicalKrakenFeastWindow;
        break;
    case "heroes":
        KrakenFeastMissionWindow = HeroesKrakenFeastWindow;
}